import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const broadcasts = {
  total_audience: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/broadcasts/total_audience", params),
  total_audience_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/broadcasts/total_audience_by_date",
      params,
    ),
  audience_reach: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/broadcasts/audience_reach", params),
  audience_reach_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/broadcasts/audience_reach_by_date",
      params,
    ),
  emails_delivered: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/broadcasts/emails_delivered",
      params,
    ),
  emails_delivered_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/broadcasts/emails_delivered_by_date",
      params,
    ),
  open_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/broadcasts/open_rate", params),
  open_rate_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/broadcasts/open_rate_by_date",
      params,
    ),
  click_rate: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/broadcasts/click_rate", params),
  click_rate_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/broadcasts/click_rate_by_date",
      params,
    ),
};
